import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import {
  editEmailNotifications,
  getEmailNotifications,
} from "../../../services/settings";
import { getAxiosResponseError } from "../../../utils/functions";

export const EMAIL_NOTIFICATIONS_QUERY_KEY = ["settings", "email-notifications"];

const showError = (err) =>
  toast.error(getAxiosResponseError(err) || "Something went wrong.");

export const useEmailNotificationsQuery = () =>
  useQuery({
    queryKey: EMAIL_NOTIFICATIONS_QUERY_KEY,
    queryFn: getEmailNotifications,
    refetchOnWindowFocus: false,
    retry: 1,
  });

export const useSaveEmailNotificationsMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (notifications) => editEmailNotifications(notifications),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: EMAIL_NOTIFICATIONS_QUERY_KEY });
      toast.success("Changes saved.");
    },
    onError: showError,
  });
};
